import { CuisineCategories, CuisineTypes, RestaurantTypes } from '../../../../../modals/company/Constants';
import { Step } from '../../../../../modals/company/add-company-modal';
import { LeadSources, PosSystems } from '../../../../../modals/company/add-company-modal/BusinessDetails';
import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Restaurant-Registrierung',
  description: 'Schritt {{activeStep}} von {{totalSteps}}',
  steps: {
    [Step.BasicInfo]: 'Grundlegende Informationen',
    [Step.BusinessDetails]: 'Geschäftliche Details',
  },
  form: {
    name: {
      label: 'Name des Restaurants',
      placeholder: 'Name des Restaurants eingeben',
    },
    timezone: {
      label: 'Zeitzone',
      placeholder: 'Nach Stadt oder Zeitzone suchen',
      inference_failed: 'Wir konnten die Zeitzone aus dieser Adresse nicht ermitteln — bitte wählen Sie sie aus.',
    },
    google_place: {
      label: 'Ausgewählter Google-Platz: {{name}}',
    },
    is_franchise: {
      label: 'Das Restaurant ist Teil einer Marke.',
    },
    other_platforms: {
      label: 'Aktuelle Lieferplattformen',
      description: 'Wählen Sie alle Plattformen aus, auf denen Sie derzeit gelistet sind.',
    },
    pos_system: {
      label: 'Aktuelles Kassensystem',
      placeholder: 'Wählen Sie Ihr Kassensystem aus',
      options: {
        [PosSystems.Other]: 'Andere',
      },
    },
    delivery_mode: {
      label: 'Liefermodus',
      placeholder: 'Liefermodus auswählen',
      options: {
        [DeliveryMode.Internal]: 'Intern (eigene Fahrer)',
        [DeliveryMode.External]: 'Extern (Drittanbieter)',
      },
    },
    monthly_sales_other_platforms: {
      label: 'Monatlicher Lieferumsatz',
      description: 'Gesamtumsatz über alle Lieferplattformen hinweg',
      placeholder: 'Verkaufsbereich auswählen',
      options: {
        other: 'Sonstiges',
      },
      other: {
        placeholder: 'Verkaufsbetrag eingeben',
      },
    },
    lead_source: {
      label: 'Lead-Quelle',
      description: 'Wie haben Sie von uns erfahren?',
      options: {
        [LeadSources.SDR]: {
          title: 'SDR',
          description: 'Vertriebsentwicklungsbeauftragter',
        },
        [LeadSources.Inbound]: {
          title: 'Eingehend',
          description: 'Über die Website oder Marketing zu uns gekommen',
        },
        [LeadSources.Referral]: {
          title: 'Empfehlung – Bestehendes Restaurant',
          description: 'Empfohlen von einem unserer Partnerrestaurants',
        },
        [LeadSources.SelfGeneratedCold]: {
          title: 'Selbst erzeugt – Kalt',
          description: 'Durch Kaltakquise oder Prospektion gefunden',
        },
        [LeadSources.SelfGeneratedReferral]: {
          title: 'Selbst generiert – Empfehlung',
          description: 'Persönliches Netzwerk oder Verbindung',
        },
        [LeadSources.Tipster]: {
          title: 'Tippgeber',
          description: 'Foodamigos bezahlt Person/Unternehmen X an Provision für die Empfehlung',
        },
      },
    },
    sdr: {
      description: 'Wähle den SDR aus, der für die Generierung dieses Leads verantwortlich ist',
    },
    has_instagram_profile: {
      label: 'Instagram-Profil',
      description: 'Hat Ihr Restaurant ein Instagram-Profil?',
      options: {
        true: 'Ja',
        false: 'Nein',
      },
    },
  },
  buttons: {
    back: 'Zurück',
    next: 'Weiter',
    complete_registration: 'Registrierung abschließen',
  },
  basic_information: {
    title: 'Grundinformationen',
    description: 'Geben Sie die grundlegenden Details und Kontaktinformationen des Restaurants ein',
  },
  restaurant_type: {
    title: 'Restauranttyp & Servicemodell',
    description: 'Wählen Sie das Format, das den Servicestil dieses Restaurants am besten beschreibt',
  },
  cuisine_type: {
    title: 'Essenskategorien & Küchenstile',
    description: 'Wählen Sie alle Essenskategorien und Küchenstile aus, die auf dieses Restaurant zutreffen',
    placeholder: 'Küchenstile suchen',
  },
  business_details: {
    title: 'Geschäftliche Details',
    description: 'Helfen Sie uns, Ihre aktuellen Abläufe zu verstehen',
  },
  restaurant_types: {
    [RestaurantTypes.FullServiceRestaurant]: {
      title: 'Full-Service-Restaurant',
      description: 'Sitzendes Essen mit Tischservice',
    },
    [RestaurantTypes.FastCasual]: {
      title: 'Schnell und ungezwungen',
      description:
        'Bestellung am Tresen/über die App, höhere Qualität und Individualisierung als bei Schnellrestaurants, Sitzplätze optional',
    },
    [RestaurantTypes.QuickServiceTakeaway]: {
      title: 'Schnellrestaurants (QSR) / Takeaway',
      description: 'Schneller Service an der Theke; hauptsächlich zum Mitnehmen',
    },
    [RestaurantTypes.CafeAndBakery]: {
      title: 'Café & Bäckerei',
      description: 'Kaffee, Gebäck, leichte Mahlzeiten, Frühstück/Brunch',
    },
    [RestaurantTypes.DessertAndIceCream]: {
      title: 'Dessert & Eiscreme',
      description: 'Süßigkeiten-orientierte Konzepte',
    },
    [RestaurantTypes.DrinksAndBar]: {
      title: 'Getränke & Bar',
      description:
        'Getränkegesteuerte Veranstaltungsorte; Speisen optional; Alkoholauslieferung unterliegt den örtlichen Vorschriften',
    },
    [RestaurantTypes.DeliveryOnlyOrGhostKitchen]: {
      title: 'Nur Lieferung / Ghost Kitchen',
      description: 'Keine Ladenfront; virtuelle Marken und Cloud-Küchen',
    },
  },
  cuisine_types: {
    [CuisineTypes.Pizza]: 'Pizza',
    [CuisineTypes.Burgers]: 'Burgers',
    [CuisineTypes.ChickenFried]: 'Chicken Fried',
    [CuisineTypes.Wings]: 'Wings',
    [CuisineTypes.KebabDoner]: 'Kebab/Doner',
    [CuisineTypes.Sandwiches]: 'Sandwiches',
    [CuisineTypes.Wraps]: 'Wraps',
    [CuisineTypes.Salads]: 'Salads',
    [CuisineTypes.Healthy]: 'Healthy',
    [CuisineTypes.Bowls]: 'Bowls',
    [CuisineTypes.Vegan]: 'Vegan',
    [CuisineTypes.Vegetarian]: 'Vegetarian',
    [CuisineTypes.GlutenFree]: 'Gluten Free',
    [CuisineTypes.Halal]: 'Halal',

    [CuisineTypes.Sushi]: 'Sushi',
    [CuisineTypes.Japanese]: 'Japanese',
    [CuisineTypes.Ramen]: 'Ramen',
    [CuisineTypes.UdonSoba]: 'Udon/Soba',
    [CuisineTypes.Korean]: 'Korean',
    [CuisineTypes.KoreanFriedChicken]: 'Korean Fried Chicken',
    [CuisineTypes.Chinese]: 'Chinese',
    [CuisineTypes.Sichuan]: 'Sichuan',
    [CuisineTypes.CantoneseDimSum]: 'Cantonese/Dim Sum',
    [CuisineTypes.Thai]: 'Thai',
    [CuisineTypes.Vietnamese]: 'Vietnamese',
    [CuisineTypes.Malaysian]: 'Malaysian',
    [CuisineTypes.Indonesian]: 'Indonesian',
    [CuisineTypes.Filipino]: 'Filipino',
    [CuisineTypes.Poke]: 'Poke',
    [CuisineTypes.HotPot]: 'Hot Pot',
    [CuisineTypes.DumplingsGyozaBao]: 'Dumplings/Gyoza/Bao',

    [CuisineTypes.Indian]: 'Indian',
    [CuisineTypes.Biryani]: 'Biryani',
    [CuisineTypes.Pakistani]: 'Pakistani',
    [CuisineTypes.SriLankan]: 'Sri Lankan',
    [CuisineTypes.Nepalese]: 'Nepalese',

    [CuisineTypes.Turkish]: 'Turkish',
    [CuisineTypes.Lebanese]: 'Lebanese',
    [CuisineTypes.Syrian]: 'Syrian',
    [CuisineTypes.Israeli]: 'Israeli',
    [CuisineTypes.Egyptian]: 'Egyptian',
    [CuisineTypes.PersianIranian]: 'Persian/Iranian',
    [CuisineTypes.Iraqi]: 'Iraqi',
    [CuisineTypes.Afghan]: 'Afghan',
    [CuisineTypes.ShawarmaFalafel]: 'Shawarma/Falafel',
    [CuisineTypes.MezzeGrill]: 'Mezze/Grill',
    [CuisineTypes.Greek]: 'Greek',
    [CuisineTypes.Mediterranean]: 'Mediterranean',

    [CuisineTypes.Italian]: 'Italian',
    [CuisineTypes.Pasta]: 'Pasta',
    [CuisineTypes.French]: 'French',
    [CuisineTypes.SpanishTapas]: 'Spanish/Tapas',
    [CuisineTypes.Portuguese]: 'Portuguese',
    [CuisineTypes.German]: 'German',
    [CuisineTypes.Austrian]: 'Austrian',
    [CuisineTypes.Balkan]: 'Balkan',
    [CuisineTypes.Hungarian]: 'Hungarian',
    [CuisineTypes.Polish]: 'Polish',
    [CuisineTypes.Czech]: 'Czech',
    [CuisineTypes.Georgian]: 'Georgian',

    [CuisineTypes.Mexican]: 'Mexican',
    [CuisineTypes.TexMex]: 'Tex-Mex',
    [CuisineTypes.Peruvian]: 'Peruvian',
    [CuisineTypes.Brazilian]: 'Brazilian',
    [CuisineTypes.Argentinian]: 'Argentinian',
    [CuisineTypes.Caribbean]: 'Caribbean',
    [CuisineTypes.BBQAmerican]: 'BBQ/American',
    [CuisineTypes.Steakhouse]: 'Steakhouse',
    [CuisineTypes.AmericanGeneral]: 'American (General)',
    [CuisineTypes.HotDogs]: 'Hot Dogs',

    [CuisineTypes.Seafood]: 'Seafood',
    [CuisineTypes.FishAndChips]: 'Fish and Chips',
    [CuisineTypes.SteamedFish]: 'Steamed Fish',

    [CuisineTypes.BreakfastBrunch]: 'Breakfast/Brunch',
    [CuisineTypes.Bagels]: 'Bagels',
    [CuisineTypes.Bakery]: 'Bakery',
    [CuisineTypes.PastryDessert]: 'Pastry/Dessert',
    [CuisineTypes.WafflesCrepes]: 'Waffles/Crepes',
    [CuisineTypes.IceCreamGelato]: 'Ice Cream/Gelato',
    [CuisineTypes.Donuts]: 'Donuts',
    [CuisineTypes.Cakes]: 'Cakes',

    [CuisineTypes.CoffeeCafe]: 'Coffee/Cafe',
    [CuisineTypes.BubbleTea]: 'Bubble Tea',
    [CuisineTypes.JuiceSmoothies]: 'Juice/Smoothies',
    [CuisineTypes.Milkshakes]: 'Milkshakes',
    [CuisineTypes.BarPub]: 'Bar/Pub',
    [CuisineTypes.WineBar]: 'Wine Bar',
    [CuisineTypes.Cocktails]: 'Cocktails',

    [CuisineTypes.TapasMezeSmallPlates]: 'Tapas/Mezze/Small Plates',
    [CuisineTypes.Noodles]: 'Noodles',
    [CuisineTypes.Soup]: 'Soup',
    [CuisineTypes.Schnitzel]: 'Schnitzel',
    [CuisineTypes.SoulFood]: 'Soul Food',
    [CuisineTypes.ComfortFood]: 'Comfort Food',
    [CuisineTypes.StreetFood]: 'Street Food',
    [CuisineTypes.OrganicBio]: 'Organic/Bio',
    [CuisineTypes.KidsMenu]: 'Kids Menu',
  },
  cuisine_categories: {
    [CuisineCategories.TopGeneral]: 'Top/General',
    [CuisineCategories.AsianPacific]: 'Asian/Pacific',
    [CuisineCategories.SouthAsian]: 'South Asian',
    [CuisineCategories.MiddleEastMediterranean]: 'Middle East/Mediterranean',
    [CuisineCategories.Europe]: 'Europe',
    [CuisineCategories.Americas]: 'Americas',
    [CuisineCategories.SeafoodSpecialty]: 'Seafood Specialty',
    [CuisineCategories.BreakfastBakerySweets]: 'Breakfast Bakery/Sweets',
    [CuisineCategories.BeverageLed]: 'Beverage Led',
    [CuisineCategories.OtherConcepts]: 'Other Concepts',
  },
};
